import { apiService } from "@/common/api.service.js";

export default {

  initialLoginCredentials(payload) {
    let endpoint = `/auth/initial-credentials/${payload}/`;
     return apiService(endpoint);
  },
  completeInitialSetup(payload) {
    let endpoint = `/auth/initial-setup/${payload.initial_login_id}/`;
    return apiService(endpoint, "POST", payload)
  },

}